const feedItemSHoverEffect = ()=> {
  let items = document.querySelectorAll('.oxg-feed-item-s');
  if (!items) return;
  items.forEach((item) => {
    addHoverClass(item, 'hovering');
  })
}

function addHoverClass(element, className) {
  function removeClass() {
    element.classList.remove(className);
    let headings = element.querySelectorAll('.heading');
    if(headings) {
      Array.from(headings).forEach(heading => {
        heading.classList.remove('blink');
      })
    }

    // if (heading) {
    //   heading.classList.remove('blink');
    // }
  }

  element.addEventListener('mouseenter', () => {
    element.classList.add(className);
    let headings = element.querySelectorAll('.heading');
    if(headings) {
      Array.from(headings).forEach(heading => {
        heading.classList.add('blink');
      })
    }
    // let heading = element.querySelector('.heading');
    // if (heading) {
    //   heading.classList.add('blink');
    // }
  });
  element.addEventListener('mouseleave', removeClass);

  // Handle window/tab switches
  window.addEventListener('blur', removeClass);
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) removeClass();
  });
}

document.addEventListener('DOMContentLoaded', () => {
  feedItemSHoverEffect();
});